<script setup lang="ts">
import { ref } from 'vue';
import { useDialog } from 'primevue/usedialog';
import { useI18n } from 'vue-i18n';
import { useUserAuthorizationsStore } from '@/store/UserAuthorizationsStore';
import Button from 'primevue/button';
import Tab from 'primevue/tab';
import TabList from 'primevue/tablist';
import TabPanel from 'primevue/tabpanel';
import TabPanels from 'primevue/tabpanels';
import Tabs from 'primevue/tabs';
import TourGateway from '@/views/internal/Tour/TourGateway.vue';
import TourDetails from '@/views/internal/Tour/TourDetails.vue';
import AutomatedTourSearchModal from '@/components/modal/AutomatedTourSearchModal.vue';

const dialog = useDialog();
const { t } = useI18n({ useScope: 'global' });
const userAuthorizationsStore = useUserAuthorizationsStore();
const authorizations: any = userAuthorizationsStore.permissionByRole;
const refTourGateway = ref();
const refTourDetails = ref();

const openModalAutoSearch = () => {
  const dialogRef = dialog.open(AutomatedTourSearchModal, {
    props: {
      header: t('management.tour.add_tour_content'),
      modal: true,
      style: {
        width: '84vw'
      }
    },
    emits: {
      onClose: () => {
        handleRefreshData();
        dialogRef.close();
      }
    }
  });
};

const handleRefreshData = () => {
  if (refTourGateway.value) {
    refTourGateway.value.getTourGateway();
  } else {
    refTourDetails.value.getListTourDetail();
  }
};
</script>
<template>
  <div class="card tour-management">
    <div class="flex justify-content-between">
      <h3 class="h5style">{{ $t('management.tour.tour_management') }}</h3>
      <Button v-if="authorizations.tour_combination_configuration.automated_tour_addition" icon="pi pi-plus" :label="$t('management.tour.add_auto')" data-testid="btn_auto_search" class="auto-search-btn" @click="openModalAutoSearch()" />
    </div>
    <Tabs :value="0" lazy>
      <TabList>
        <Tab :key="0" :value="0">{{ $t('management.tour.tour_gateway_destination') }}</Tab>
        <Tab :key="1" :value="1">{{ $t('management.tour.tour_details') }}</Tab>
      </TabList>
      <TabPanels>
        <TabPanel :key="0" :value="0"><TourGateway ref="refTourGateway"></TourGateway></TabPanel>
        <TabPanel :key="1" :value="1"><TourDetails ref="refTourDetails"></TourDetails></TabPanel>
      </TabPanels>
    </Tabs>
  </div>
</template>
